<template>
  <div class="horse-list">
		<table>
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue">
							<h3>Item Name</h3>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, i) in equipment" :key="i">
					<td class="name">{{ item.name }}</td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', item)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button class="button-transparent" @click="$emit('delete', item)">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="equipment.length === 0">
					<td colspan="6">No equipment found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['equipment']
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Equipment/List.vue